import React, { createContext, useContext, useState, useEffect } from 'react';
import { getLanguage, getSupportedLanguages } from '../lang';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Get saved language from localStorage or default to 'hu'
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    return savedLanguage || 'hu';
  });

  const [translations, setTranslations] = useState(() => getLanguage(currentLanguage));

  // Save language preference to localStorage
  useEffect(() => {
    localStorage.setItem('selectedLanguage', currentLanguage);
    document.documentElement.lang = currentLanguage;
    setTranslations(getLanguage(currentLanguage));
  }, [currentLanguage]);

  const changeLanguage = (langCode) => {
    if (getSupportedLanguages().find(lang => lang.code === langCode)) {
      setCurrentLanguage(langCode);
    }
  };

  // Helper function to get nested translation values
  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Return the key if translation not found (for debugging)
        return key;
      }
    }
    
    return value || key;
  };

  const value = {
    currentLanguage,
    translations,
    supportedLanguages: getSupportedLanguages(),
    changeLanguage,
    t,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};